/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'
import React, { useState, useRef } from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeXmark, faVolumeHigh } from '@fortawesome/free-solid-svg-icons'
import CIIcon from './CIIcon'

function ShowVideoPreview({ srcs, redirectUrl }) {
  const [isVisible, setIsVisible] = useState(true)

  const { file } = srcs[0]
  const videoKey = srcs[0].key
  const [isMuted, setIsMuted] = useState(true)
  const videoRef = useRef(null)

  if (!(file instanceof Blob)) {
    return <div className="text-danger">上傳的檔案無效，請重新選擇影片</div>
  }

  return isVisible ? (
    <div className="show-video-wrapper">
      <div className="video-bg" />

      <Button className="close-btn" onClick={() => setIsVisible(false)}>
        ✕
      </Button>

      <video
        ref={videoRef}
        autoPlay
        muted={isMuted}
        loop
        className="video-player"
        onClick={() => {
          if (redirectUrl) window.open(redirectUrl, '_blank')
        }}
      >
        <source src={URL.createObjectURL(file)} type="video/mp4" />
        <track kind="captions" />
      </video>
      <CIIcon bottom="5%" />
      <div
        role="presentation"
        onClick={(e) => {
          e.stopPropagation()
          const newMuted = !isMuted
          setIsMuted(newMuted)
          if (videoRef.current) {
            videoRef.current.muted = newMuted
          }
        }}
        style={{
          position: 'absolute',
          left: '0px',
          bottom: '5px',
          zIndex: 1100,
          backgroundColor: 'rgba(0,0,0,0.5)',
          borderRadius: '50%',
          width: '22px',
          height: '22px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <FontAwesomeIcon
          icon={isMuted ? faVolumeXmark : faVolumeHigh}
          style={{ color: 'white', fontSize: '12px' }}
        />
      </div>
    </div>
  ) : (
    <div className="show-video-wrapper">
      <div className="video-bg" />

      <Button className="close-btn" onClick={() => setIsVisible(false)}>
        ✕
      </Button>

      <video
        key={videoKey + Date.now()}
        controls
        autoPlay
        muted
        loop
        className="video-player"
      >
        <source src={URL.createObjectURL(file)} type="video/mp4" />
        <track kind="captions" />
      </video>
      <CIIcon bottom="5%" />
    </div>
  )
}

ShowVideoPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.instanceOf(Blob).isRequired,
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
  redirectUrl: PropTypes.string.isRequired,
}

export default ShowVideoPreview
